import Vue from 'vue';
import ABaseComponent from 'Components/Base/ABaseComponent';
import Component from 'vue-class-component';
import { VueReCaptcha } from 'vue-recaptcha-v3'
import ApiFactory from 'Api/ApiFactory';
import { Prop } from 'vue-property-decorator';
import AlertEventBus, {IAlert} from 'Events/AlertEventBus';
import ComponentEventBus, { IComponentWrapper, Events as ComponentWrapperEvent } from 'Events/ComponentWrapperEventBus';

import AlertSuccessComponent, {name as AlertSuccessName} from "Components/Utils/Alerts/AlertSuccessComponent"; 
import AlertWarningComponent, {name as AlertWarningName} from "Components/Utils/Alerts/AlertWarningComponent"; 

import {ActionStatusViewModel } from 'Api/DynamicwebApi';
import Axios, { AxiosRequestConfig, AxiosResponse, CancelTokenSource } from 'axios';
import { readyException } from 'jquery';
import ReCaptchaComponent from './ReCaptchaComponent';

declare global {
    interface Window {
        NORRIQ: {
            initFormValidation: () => void;
        }
    }
}

// import OrderingListNewChildDebitorComponent from "Components/CustomerCenter/OrderingListUser/OrderinglistNewChildDebitor";

@Component({
    template: '#formula-wrapper-template',
    components: {
        // HTMLRender,
        // OrderingListNewChildDebitorComponent
    }
})
export default class FormulaComponentAsync extends ABaseComponent {
    
    @Prop()
    public getFormUrl : string;
    
    @Prop()
    public transformPostToJson: boolean;
    
    @Prop()
    public useReCaptcha: boolean;
    
    @Prop()
    public disableReSubmit: boolean;
    
    @Prop()
    public allowRedirect: boolean;
    
    public isPosting: boolean = false;
    
    
    
    
    
    
    //Clean HTML from async call
    public html: any = null;
    
    //HTML ref after is being added to DOM
    private _innerHTML: HTMLElement = null;
    
    //Form Submit button
    private _submitBtn: HTMLButtonElement = null;

     // Cancel request
     cancelSource: CancelTokenSource = null;
    
    /*
    * 1. get HTML
    * 2. add validation from jquery (global call)
    * 3. submit form to (glabl element)
    * 4. Errors handling > alert model
    */
    async created() {
        this.setLoading();
    }

    async mounted() {
        await this.init();
        this.setLoaded();
    }

    async init(){
        
        
        if(!this.getFormUrl) return;
        
        const formBody = await this.getForm(this.getFormUrl);
        this.html = <any>Vue.compile(formBody);

        const self = this;
        
        setTimeout(() => {
            
            this._innerHTML  = <HTMLElement>this.$refs.html;
            const htmlForm = this._innerHTML.querySelector('form');
            htmlForm.noValidate = true;
            
            // (<any>window.NORRIQ).initFormValidation();
            
            this._submitBtn = <HTMLInputElement>htmlForm.querySelector('[type="submit"]');
            this._submitBtn.append((<HTMLElement>this.$refs.postingspinner));
            
            const ReCaptchaComponent = this.$refs.recaptchacomponent;
            console.debug("DEBUG window.NORRIQ: ", window.NORRIQ);
            const norriq = window.NORRIQ as any;
            if (norriq) {
                norriq.form.useJQueryValidation('#'+htmlForm.id);
            }
            
            
            htmlForm.onsubmit = (async (event: Event) => {            
                event.preventDefault();
                this._submitBtn.disabled = true;
                const submitForm = <HTMLFormElement>event.target;
                                
                if(this.useReCaptcha){
                    await (<ReCaptchaComponent>ReCaptchaComponent).validate(submitForm);
                }             
                //we needs to wait in case the DOM has changed       
                Vue.nextTick(async () => {
                    
                    await this.onSubmit(submitForm);
                })
            });
            
        },0);
        
        
    }
    
    
    async onSubmit(form: HTMLFormElement){
        const successMsg = this._innerHTML.querySelector('[data-translation-success]')?.innerHTML;
        const notValidMsg = document.querySelector('[data-translation-form-is-not-valid]')?.innerHTML;
        const errorMsg = document.querySelector('[data-translation-form-has-errors]')?.innerHTML;
        this._submitBtn.disabled = true;
        
        ComponentEventBus.$emit(ComponentWrapperEvent.REMOVE, <IComponentWrapper>{type: AlertWarningName}); 
        ComponentEventBus.$emit(ComponentWrapperEvent.REMOVE, <IComponentWrapper>{type: AlertSuccessName}); 
        
        if(form.checkValidity()){
            
            //TODO: mso - handle 500 exceptions
            this.isPosting = true;
            const response = await this.getFormPostResult(form);
            const contentStatus = this.getStatus(response);
            
            if((response.status >= 200 && response.status <= 202) && contentStatus.isSuccess){ //check content for "error messages"
            
            ComponentEventBus.$emit(ComponentWrapperEvent.ADD, <IComponentWrapper>{type: AlertSuccessName});
            
            //it is better safe to wait till the component is initialized and mounted!
            setTimeout(() => {
                AlertEventBus.$emit('show-alert', {
                    header: contentStatus.message ?? successMsg,
                    message: '', 
                });
            },0);
            this.isPosting = false;
            if(!this.disableReSubmit)
            {
                //allow the user to make a new submit
                this._submitBtn.disabled = false;
            }
            //emit updated object to other objects..
            this.$emit('updatedValues', this.convertPostDataToObject(new FormData(form)));
            
            return true; //return if every is "OK"
        }
        //handle server redircts
        else if(!this.hasContentErrors(response) && this.allowRedirect && response.status >= 200 && response.status <= 302 && response.request && response.request.responseURL){
            //redirect to redict link 
            ComponentEventBus.$emit(ComponentWrapperEvent.ADD, <IComponentWrapper>{type: AlertSuccessName});
            
            //it is better safe to wait till the component is initialized and mounted!
            setTimeout(() => {
                AlertEventBus.$emit('show-alert', {
                    header: contentStatus.message ?? successMsg,
                    message: '', 
                });
            },0);
            this.isPosting = false;
            if(!this.disableReSubmit)
            {
                //allow the user to make a new submit
                this._submitBtn.disabled = false;
            }
            
            setTimeout(() => {
                window.location.href = response.request.responseURL;
            },10);
            
            return true;
        }
        
        ComponentEventBus.$emit(ComponentWrapperEvent.ADD, <IComponentWrapper>{type: AlertWarningName}); 
        setTimeout(() => {
            
            if(!contentStatus.errors || contentStatus.errors.length == 0){
                contentStatus.errors = [errorMsg];
            }
            
            contentStatus.errors.forEach((value: string, index: number) => {
                AlertEventBus.$emit('show-alert', {
                    header: contentStatus.message, 
                    message: value, 
                });
            });
            
        },0);
        this.isPosting = false;
        
        //TODO: mso when you are boring MAKE html validation : https://codesandbox.io/s/5zmz9q9m0p?file=/src/components/CustomDesign.vue
        
    } //end form is valid
    else{
        ComponentEventBus.$emit(ComponentWrapperEvent.ADD, <IComponentWrapper>{type: AlertWarningName});
        
        setTimeout(() => {
            AlertEventBus.$emit('show-alert', {
                header: notValidMsg, 
                message: '', 
            });
        },0);
        
    }
    //initialize component
    
    
    this.isPosting = false;
    //allow the user to make a new submit
    this._submitBtn.disabled = false;
    return false;
}




async getFormPostResult(form: HTMLFormElement): Promise<AxiosResponse<any>>{
    try {
        var that = this;
        if (this.cancelSource) {
            this.cancelSource.cancel();
        }
        const cancelToken = Axios.CancelToken;
        this.cancelSource = cancelToken.source();
        const formHtml = form.outerHTML;
        console.log('inner html',form);
        const response = await this.axios.post(form.action,
            this.convertPostData(form),
            <AxiosRequestConfig>{ //form.action
                cancelToken: this.cancelSource.token
            });
        // Hvis der oprettes ny k�bskonto har form dette name, og der skal sendes mail til kundeservice 
        if (formHtml.includes('name="UserManagementEditForm"')) {
            var formElements = $(form);
            var firmName = $("input[name=UserManagement_Form_Company]", formElements).val();
            var parentCustNumber = $("input[name=parentCustomerNumber]", formElements).val();//parentCustomerNumber
            await that.axios.get(
                    '/customcode/customerservicemail/sendmail.ashx?auser='+parentCustNumber+'&newuser='+firmName);
        }
        return response;
    }catch(err){
        console.debug('getFormPostResult',err);
        ComponentEventBus.$emit(ComponentWrapperEvent.ADD, <IComponentWrapper>{type: AlertWarningName}); 
        setTimeout(() => {
            AlertEventBus.$emit('show-alert', {
                header: 'Error', 
                message: err, 
            });
        },0);
    }
}


async getForm(uri: string): Promise<string>{
    const response = await this.axios.get(uri);
    return response.data;
    
}


convertPostData(form: HTMLFormElement) : any{
    const formData = new FormData(form);
    if(this.transformPostToJson || form.action.indexOf(this.getFormUrl) == -1){
        return this.convertPostDataToObject(formData);
    }
    return formData;
}

convertPostDataToObject(formData: FormData){
    var obj : {[k: string]: any} = {};;
    formData.forEach((value: FormDataEntryValue, key : string) => {
        // console.debug('formdata key:',key,' value: ', value);
        obj[key] = value;
    });
    return obj;
}


getStatus(response: AxiosResponse<any>): ActionStatusViewModel{
    const statusModel = ActionStatusViewModel.fromJS(response.data);
    
    //capture page errors "CMS exceptions"
    if(!statusModel.isSuccess && this.hasContentErrors(response))
    {
        statusModel.isSuccess = false;
    }
    return statusModel;
}


hasContentErrors(response: AxiosResponse<any>): boolean{
    //capture page errors "CMS exceptions"
    if((typeof response.data === 'string' || response.data instanceof String) 
    && (response.data.substring(0,200).indexOf('exception') > -1 || response.data.substring(0,200).indexOf('error') > -1))
    {
        return true;
    }
    return false;
}


}
Vue.component('formula-wrapper', FormulaComponentAsync);